var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4078 12.2773C16.5258 14.624 14.7257 16.5074 12.4528 17.469C12.0683 17.6324 11.7001 17.2174 11.8981 16.8424C12.515 15.6657 12.9797 14.099 13.235 12.2773H17.4078Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0694 12.2773C11.5408 15.7657 10.2153 18.0007 8.99952 18.0007C7.7837 18.0007 6.45824 15.7657 5.92969 12.2773H12.0694Z",
    fill: "#787878"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54771 17.469C3.27479 16.5074 1.47478 14.624 0.592773 12.2773H4.76552C5.02079 14.099 5.48552 15.6657 6.10244 16.8424C6.30044 17.2174 5.93225 17.6324 5.54771 17.469Z",
    fill: "#787878"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54748 9.00069C4.54748 9.72902 4.57693 10.434 4.6342 11.1107H0.240547C0.083455 10.434 0 9.72736 0 9.00069C0 8.23402 0.0916368 7.48901 0.266729 6.77734H4.64566C4.58184 7.48901 4.54748 8.23235 4.54748 9.00069Z",
    fill: "#787878"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3066 9.00069C12.3066 9.73736 12.2739 10.4424 12.2101 11.1107H5.78893C5.72511 10.4424 5.69238 9.73736 5.69238 9.00069C5.69238 8.22235 5.73002 7.47901 5.79875 6.77734H12.2002C12.269 7.47901 12.3066 8.22235 12.3066 9.00069Z",
    fill: "#787878"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 9.00069C18.0002 9.72736 17.9167 10.434 17.7596 11.1107H13.3659C13.4232 10.434 13.4527 9.72902 13.4527 9.00069C13.4527 8.23235 13.4183 7.48901 13.3545 6.77734H17.7334C17.9085 7.48901 18.0002 8.23402 18.0002 9.00069Z",
    fill: "#787878"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.365 5.61026H13.2184C12.9599 3.83026 12.4984 2.30025 11.8913 1.14691C11.6982 0.778574 12.0729 0.371906 12.4526 0.531906C14.6879 1.47858 16.4682 3.31525 17.365 5.61026Z",
    fill: "#787878"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0519 5.61003H5.94824C6.48824 2.18668 7.79734 0 9.00008 0C10.2028 0 11.5119 2.18668 12.0519 5.61003Z",
    fill: "#787878"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10843 1.14691C5.50134 2.30025 5.03988 3.83026 4.78133 5.61026H0.634766C1.5315 3.31525 3.31187 1.47858 5.54715 0.531906C5.92679 0.371906 6.30152 0.778574 6.10843 1.14691Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/websiteIcon.a7b96f7e20d2dab6295bd3dd6dcfede9.svg";
export { ForwardRef as ReactComponent };